import React, { useEffect, useState } from 'react'
import { useGetMovementReportQuery } from '../../store/api/movementApi'
import Logo from '../tools/Logo';
import PDFMaterialIssueGeneratorReport from '../tools/PDFMaterialIssueGeneratorReport';


export default function MovementReport() {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [genId, setGenId] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  // --
  const [movements, setMovement] = useState([])
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(30);
  const { data, error, isLoading } = useGetMovementReportQuery({
    refetchOnMountOrArgChange: false
  })



  useEffect(() => {
    if (data) {
      setMovement(data)
    }
  }, [data])

  useEffect(() => {
    const filterData = () => {
      let filtered = movements;

      // Filter by date range
      if (startDate && endDate) {
        filtered = filtered.filter(item => item?.actionDate >= startDate && item?.actionDate <= endDate);
      }

      // Filter by genId
      if (genId) {
        filtered = filtered.filter(item => item?.genId.toLowerCase().includes(genId.toLowerCase()));
      }

      setFilteredData(filtered);
    };

    filterData();
  }, [startDate, endDate, genId, movements]);






  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
        <div className="color-text fs-4">Loading...</div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
        <div className="row">
          <div className="col-12 opacity-75 bg-light p-4 rounded-3 shadow-md border">
            <h3 className="text-danger">Opps!!!</h3>
            <span className="fs-4">
              <span className="text-danger"> An Error has occurred</span>
            </span>
            <div className="fs-5"> The server is shut down 😢</div>
          </div>
        </div>
      </div>
    )
  }



  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleItemsPerPageChange = (e) => {
    const newItemsPerPage = parseInt(e.target.value);
    const totalPages = Math.ceil(movements.length / newItemsPerPage);
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1);

    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  };


  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
  };

  const handleGenIdChange = (e) => {
    setGenId(e.target.value);
  };




  return (
    <>
      <div className="block-content block-content-full">
        <h2 className="content-heading text-uppercase">Stock movements </h2>
      </div>
      <div className="block1">
        <div className="block-content block-content-full">
          <div className="row">
            <div className="col-md-4 mb-3">
              <label htmlFor="startDate" className="form-label">Start Date</label>
              <input style={{ height: '45px' }} type="date" className="form-control" id="startDate" value={startDate} onChange={handleStartDateChange} />
            </div>
            <div className="col-md-4 mb-3">
              <label htmlFor="endDate" className="form-label">End Date</label>
              <input style={{ height: '45px' }} type="date" className="form-control" id="endDate" value={endDate} onChange={handleEndDateChange} />
            </div>
            <div className="col-md-4 mb-3">
              <label htmlFor="genId" className="form-label">Invoice ID</label>
              <input style={{ height: '45px' }} type="text" className="form-control" id="genId" value={genId} onChange={handleGenIdChange} />
            </div>
          </div>
         
          <div>

            <div className="table-responsive position-relative" style={{ overflowX: 'auto' }}>
              <table class="table mb-5 " style={{ minWidth: '800px' }}>
                <thead className='table-secondary'>
                  <tr>
                    <th scope="col">Id</th>
                    <th scope="col">Name</th>
                    <th scope="col">Quantity</th>
                    <th scope="col">Unit</th>
                    <th scope="col">Issue Type</th>
                    <th scope="col">Amount</th>
                    <th scope="col">Total</th>
                    <th scope="col">Create At</th>
                    <th scope="col">
                      <button title='Download' className='btn bg-success border-0' onClick={() => PDFMaterialIssueGeneratorReport('Material Issues Report', startDate, endDate, currentItems)}>
                        <Logo _width={25} name={'../../../image/icons/download.svg'} _color={'#01574E'} _height={20} _marginLeft={0} />
                      </button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {

                    currentItems.map((data, dataIndex) => {

                      return <>
                        <tr>
                          <td>{data.genId}</td>
                          <td>{data.name}</td>
                          <td>{data.qty}</td>
                          <td>{data.unit}</td>
                          <td>
                            {
                              data.type === 'ToSupplier' ? (
                                <span className="rounded-1 pb-1 py-1 px-3 bg-info  text-center text-white  text-capitalize">
                                  {data.type.replace(/([A-Z])/g, ' $1').trim()}
                                </span>
                              ) :   data.type === 'ToStock' ? (
                                <span className="rounded-1 pb-1 py-1 px-3 bg-primary  text-center text-white  text-capitalize">
                                  {data.type.replace(/([A-Z])/g, ' $1').trim()}
                                </span>
                              ) : (
                                <span className="rounded-1 pb-1 py-1 px-3 bg-success  text-center text-white  text-capitalize">
                                  {data.type.replace(/([A-Z])/g, ' $1').trim()}
                                </span>
                              )
                            }
                          </td>
                          <td>{`$${(+data.amount || 0).toFixed(2)}`}</td>
                          <td>{`$${(Math.round((data.total || 0) * 100) / 100).toFixed(2)}`}</td>
                          <td colSpan="6" >{data.actionDate}</td>
                        </tr>

                      </>
                    })
                  }
                  <tr>
                    <td colSpan="6" className="text-right"><strong>General Total</strong></td>
                    <td><strong>{`$${currentItems && currentItems.length > 0 && currentItems.reduce((sum, item) => sum + item.total, 0).toFixed(2)}`}</strong></td>
                    <td colSpan="2"></td> {/* Adding empty cells to align with columns */}
                  </tr>
                </tbody>
              </table>


            </div>
          </div>

          {
            currentItems.length ? <div className='mt-4'>
              <ul className="pagination justify-content-end">

                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                  <button className="page-link" onClick={() => handlePageChange(currentPage - 1)}>Previous</button>
                </li>
                <li className="page-item disabled">
                  <span className="page-link">{currentPage}</span>
                </li>
                <li className={`page-item ${currentItems.length < itemsPerPage ? 'disabled' : ''} ${currentItems.length === filteredData.length ? 'disabled' : ''}`}>
                  <button className="page-link" onClick={() => handlePageChange(currentPage + 1)}>Next</button>
                </li>
                <li className="page-item mx-2">
                  <select className="form-select p-0 px-5 py-1 rounded-0" value={itemsPerPage} onChange={handleItemsPerPageChange}>
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                    <option value="40">40</option>
                    <option value="50">50</option>
                  </select>
                </li>
              </ul>
            </div> : <></>
          }
        </div>
      </div>
    </>

  )
}
